import { jsx } from "react/jsx-runtime";
import { TamaguiProvider as OGProvider, isRSC } from "@tamagui/core";
import { PortalProvider } from "@tamagui/portal";
const TamaguiProvider = isRSC ? OGProvider : ({ children, ...props }) => {
  return /* @__PURE__ */ jsx(OGProvider, { ...props, children: /* @__PURE__ */ jsx(PortalProvider, { shouldAddRootHost: true, children }) });
};
export {
  TamaguiProvider
};
//# sourceMappingURL=TamaguiProvider.js.map
